module.exports = __webpack_public_path__ + "img/prop.57602bd2.png";